"use client";

import { useCallback } from "react";
import { useLocationGetPublic } from "@/hooks";
import { isNotFoundError } from "@/lib/utils/media/is-not-found-error";
import {
  LocationPublicPageError,
  LocationPublicPageNotFound,
  LocationPublicPageUnavailable,
} from "./LocationPublicPageError";
import { LocationPublicPageSkeleton } from "./LocationPublicPageSkeleton";
import { LocationPublicPageView } from "./LocationPublicPageView";

export interface LocationPublicPageClientProps {
  locationId: number;
}

export const LocationPublicPageClient = ({
  locationId,
}: LocationPublicPageClientProps) => {
  const {
    data: location,
    isPending,
    isLoading,
    isError,
    isFetching,
    refetch,
    error,
  } = useLocationGetPublic(locationId, { enabled: locationId > 0 });

  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  if ((isLoading || isPending) && !location) {
    return <LocationPublicPageSkeleton />;
  }

  if (isError) {
    if (isNotFoundError(error)) {
      return <LocationPublicPageNotFound />;
    }

    return (
      <LocationPublicPageError onRetry={handleRetry} isRetrying={isFetching} />
    );
  }

  if (!location) {
    return <LocationPublicPageNotFound />;
  }

  if (!location.isActive) {
    return <LocationPublicPageUnavailable />;
  }

  return <LocationPublicPageView location={location} locationId={locationId} />;
};
